/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

export const TABS_TRANSPORT_REQUEST = {
    ASSIGNED_REQUEST: {
        INDEX: 0,
        TRANS: "assigned_requests",
    },
    OPEN_REQUEST: {
        INDEX: 1,
        TRANS: "open_request",
    },
    HISTORY: {
        INDEX: 2,
        TRANS: "history",
    }
}

export const RequestTransport = {

    item: '',
    description: '',
    originCenterId: '',
    destinationCenterId: '',
    serviceTypeId:'',
    supplierId:'',
    departureAt: null,
    deliveryAt: null,
    set: function (data) {
        return {
            ...this,
            ...data,
            destinationCenterId: data.destinationCenter.id,
            originCenterId: data.originCenter.id,
            serviceTypeId: data.serviceType.id,
            supplierId: data?.supplier?.id || '',
            statusId: data.status.id
        }
    },
    isValid: function () {
        return this.item != '' && this.description != '' && this.originCenterId != '' && this.destinationCenterId != ''
            && this.serviceTypeId != '' && this.departureAt != null && this.deliveryAt != null
    },

    toRegister: function () {
        return {
            item:this.item,
            description:this.description,
            originCenterId:this.originCenterId,
            destinationCenterId:this.destinationCenterId,
            serviceTypeId:this.serviceTypeId,
            supplierId:this.supplierId,
            departureAt: (this.departureAt instanceof Date)
                ? this.departureAt.getTime()
                : new Date(this.departureAt).getTime(),
            deliveryAt: (this.deliveryAt instanceof Date)
                ? this.deliveryAt.getTime()
                : new Date(this.deliveryAt).getTime(),
        };
    },
    clear: function (){
        return {
            ...this,
            item: '',
            description: '',
            originCenterId: '',
            destinationCenterId: '',
            serviceTypeId:'',
            supplierId:'',
            departureAt: null,
            deliveryAt: null,
        }
    }
};

